import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.187",
  height: "28.274"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m0 4 11.519-1.566.005 11.111-11.513.066zm11.514 10.826.009 11.121L.009 24.364v-9.613zm1.4-12.6L28.183 0v13.4l-15.273.121zm15.277 12.7V28.27L12.91 26.118l-.021-11.213z",
  style: {"fill":"#f59600"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };